import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import mixin from './mixins/convertor'

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel'

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: (title) => `${title} - ${appName}`,
  setup({ el, App, props, plugin }) {
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .mixin(mixin)
      .mount(el)
  },
})
